













































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
//import { LendingRevolvingCreditModule } from '@/store/Accounts/LendingRevolvingCreditModule';
//import LendingRevolvingCreditInstalmentPlanTermDefinition from '@/models/Products/LendingRevolvingCredit/LendingRevolvingCreditInstalmentPlanTermDefinition';

@Component({ name: 'LendingRevolvingCreditInstalmentPlanTermDefinitionCreate' })
export default class extends SaascadaVueDialog {

    entity = {} //new LendingRevolvingCreditInstalmentPlanTermDefinition();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.entity = {}; //new  LendingRevolvingCreditInstalmentPlanTermDefinition();
        }
    }

    get loading() {
        return false;
        //return LendingRevolvingCreditModule.loadingDialog;
    }

    get termDefinitions() {
        return {};
        //return LendingRevolvingCreditModule.createProductViewModel.instalmentPlanInterestSettings.termDefinitions;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            //await LendingRevolvingCreditModule.createLendingRevolvingCreditInstalmentPlanTermDefinition(this.entity);
        }
    }

}
